import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { fmtEUR, fmtInt } from "@/lib/api";

export const VolumeTable = ({ pricing, screen }) => {
  const [open, setOpen] = useState(false);
  return (
    <Collapsible open={open} onOpenChange={setOpen} className="mt-8">
      <CollapsibleTrigger asChild>
        <button
          data-testid="calculator-toggle-table"
          className="flex w-full items-center justify-between rounded-xl border border-black/10 bg-[#FAFAFA] px-4 py-3 text-sm font-semibold text-black/70 hover:bg-black/[0.03]"
        >
          Κλίμακα ποσότητας (τιμή/τεμάχιο)
          <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="overflow-hidden">
        <div className="mt-3 overflow-x-auto rounded-xl border border-black/10">
          <table className="w-full min-w-[480px] text-sm">
            <thead>
              <tr className="bg-[#FAFAFA] text-left text-xs text-black/50">
                <th className="px-4 py-3 font-semibold">Οθόνη</th>
                {pricing.breakpoints.map((b) => (
                  <th key={b} className="px-4 py-3 text-right font-semibold">
                    {fmtInt(b)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {pricing.screens.map((s) => (
                <tr key={s.id} className={`border-t border-black/5 ${screen === s.id ? "bg-brand-50/30" : ""}`}>
                  <td className="px-4 py-3 font-display font-semibold text-ink">{s.label}</td>
                  {pricing.breakpoints.map((b) => (
                    <td key={b} className="px-4 py-3 text-right text-black/70">
                      {fmtEUR(pricing.matrix[s.id][String(b)])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};
